import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import type DateRange from "@mapmycustomers/shared/types/range/DateRange";

import type DateRangeType from "@app/scene/reports/enums/DateRangeType";
import Scope from "@app/types/dashboard/Scope";

import { BreakdownRow } from "./types/BreakdownRow";
import { EmailSummaryMetrics } from "./types/EmailSummaryMetrics";
import { TemplatePerformance } from "./types/TemplateRow";
import { TrendDataPoint } from "./types/TrendDataPoint";

export const initialize = createAction("reports/emailActivity/initialize")();

export const setDateRange = createAction("reports/emailActivity/setDateRange")<DateRange>();
export const setDateRangeType = createAction(
  "reports/emailActivity/setDateRangeType"
)<DateRangeType>();
export const setScope = createAction("reports/emailActivity/setScope")<Scope>();
// Owner-only override of the breakdown grouping. undefined → fall back to the
// scope-derived view (current behavior). "team" or "rep" forces aggregation by
// `teams` or `createdBy` regardless of scope, so an owner on Entire-Org scope
// can group by rep across the org.
export const setBreakdownView = createAction("reports/emailActivity/setBreakdownView")<
  "rep" | "team" | undefined
>();

export const fetchBreakdown = createAsyncAction(
  "reports/emailActivity/fetchBreakdown/request",
  "reports/emailActivity/fetchBreakdown/success",
  "reports/emailActivity/fetchBreakdown/failure"
)<void, BreakdownRow[], void>();

export const fetchSummary = createAsyncAction(
  "reports/emailActivity/fetchSummary/request",
  "reports/emailActivity/fetchSummary/success",
  "reports/emailActivity/fetchSummary/failure"
)<void, EmailSummaryMetrics, void>();

export const fetchTemplates = createAsyncAction(
  "reports/emailActivity/fetchTemplates/request",
  "reports/emailActivity/fetchTemplates/success",
  "reports/emailActivity/fetchTemplates/failure"
)<void, TemplatePerformance[], void>();

export const fetchTrend = createAsyncAction(
  "reports/emailActivity/fetchTrend/request",
  "reports/emailActivity/fetchTrend/success",
  "reports/emailActivity/fetchTrend/failure"
)<void, TrendDataPoint[], void>();

export const requestEmailFeature = createAsyncAction(
  "reports/emailActivity/requestEmailFeature/request",
  "reports/emailActivity/requestEmailFeature/success",
  "reports/emailActivity/requestEmailFeature/failure"
)<void, void, void>();

export type EmailActivityActions = ActionType<
  | typeof fetchBreakdown
  | typeof fetchSummary
  | typeof fetchTemplates
  | typeof fetchTrend
  | typeof initialize
  | typeof requestEmailFeature
  | typeof setBreakdownView
  | typeof setDateRange
  | typeof setDateRangeType
  | typeof setScope
>;
